import React, { useEffect } from "react";
import { X, Check } from "lucide-react";
import { brand as ds, sx } from "../designSystem";
import { CONTRACT_TERMS, TRIAL_CANCEL_TEXT } from "../plans";

/* ════════════════════════════════════════════════════════════════════════
   TESTANGEBOT — „Eigene Handschrift 7 Tage kostenlos testen".
   ────────────────────────────────────────────────────────────────────────
   Erscheint bei allen ohne Abo nach dem ersten Download-Klick oder nach
   30 Sekunden auf der Seite (Logik und Tagesgrenze in Home.js). Dieses
   Fenster verkauft nur; bestellt wird erst in der Bestellübersicht
   (CheckoutConsent), die Preis, Laufzeit und Kündigung vollständig zeigt.
   Der Preis danach steht trotzdem schon hier — ein „gratis" ohne den
   Folgepreis daneben wäre irreführend.
   ════════════════════════════════════════════════════════════════════════ */

const VORTEILE = [
  "Deine eigene Handschrift, aus deinen Buchstaben",
  "Unbegrenzte Downloads ohne Wasserzeichen",
  "Export als GoodNotes-Datei, radierbar",
];

export default function TrialOffer({ plan, onStart, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center p-4"
      style={{
        background: ds.scrim,
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
      }}
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="sb-trial-title"
        className="relative w-full max-w-[420px] animate-fade-in"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: ds.color.surface,
          borderRadius: ds.radius.lg,
          padding: "32px 28px 24px",
          fontFamily: ds.font.body,
          color: ds.color.ink,
        }}
      >
        <button
          onClick={onClose}
          aria-label="Schließen"
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            border: "none",
            background: "transparent",
            color: ds.color.muted,
            cursor: "pointer",
            display: "inline-flex",
            padding: 4,
          }}
        >
          <X size={18} />
        </button>

        <div className="flex flex-col gap-5">
          <div className="flex flex-col gap-2">
            <span
              style={{
                alignSelf: "flex-start",
                background: ds.color.accent,
                color: "#fff",
                borderRadius: ds.radius.pill,
                padding: "4px 10px",
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              {plan.trialDays} Tage gratis
            </span>
            <h3 id="sb-trial-title" style={sx.display(ds.text.h3)}>
              Schreib in deiner eigenen Handschrift
            </h3>
            <p style={{ ...sx.caption, fontSize: 15 }}>
              Teste Schriftbot {plan.name} {plan.trialDays} Tage kostenlos.{" "}
              {TRIAL_CANCEL_TEXT}
            </p>
          </div>

          <ul
            className="flex flex-col gap-2.5"
            style={{ listStyle: "none", margin: 0, padding: 0 }}
          >
            {VORTEILE.map((v) => (
              <li
                key={v}
                className="flex items-center gap-2.5"
                style={{ fontSize: 15, lineHeight: 1.4 }}
              >
                <Check
                  size={16}
                  style={{ flex: "none", color: ds.color.accent }}
                />
                {v}
              </li>
            ))}
          </ul>

          <div className="flex flex-col gap-2">
            <button
              className="sb-btn sb-btn-primary"
              style={{ width: "100%" }}
              autoFocus
              onClick={onStart}
            >
              {plan.trialDays} Tage kostenlos testen
            </button>
            <button
              className="sb-link"
              onClick={onClose}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: ds.color.muted,
                fontFamily: ds.font.body,
                fontSize: 14,
                padding: "8px 0",
              }}
            >
              Nein danke
            </button>
          </div>

          <p style={{ ...sx.caption, fontSize: 13, textAlign: "center" }}>
            Danach {plan.price} {CONTRACT_TERMS.intervalLabel}, jederzeit
            kündbar.
          </p>
        </div>
      </div>
    </div>
  );
}
